// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"MainParagraphText_paragraph__6U2dn"};